document.addEventListener('DOMContentLoaded', function() {
  const popup = document.getElementById('checkCompatibilityPopup');
  if (!popup) return;

  const openButtons = document.querySelectorAll('.open-compatibility-popup');
  const closeButtons = document.querySelectorAll('.close-compatibility-popup');
  const tabs = popup.querySelectorAll('.compatibility-tabs__tab');
  const panels = popup.querySelectorAll('.compatibility-tabs__panel');
  const searchInputs = popup.querySelectorAll('.compatibility-search__input');

  // --- POPUP FUNCTIONALITY ---

  function openPopup() {
    popup.classList.remove('compatibility-popup--hidden');
    document.body.classList.add('compatibility-popup--open'); // For body scroll lock
  }

  function closePopup() {
    popup.classList.add('compatibility-popup--hidden');
    document.body.classList.remove('compatibility-popup--open');
    resetSearch(panels); // Reset searches when closing
  }

  openButtons.forEach(button => {
    button.addEventListener('click', openPopup);
  });

  closeButtons.forEach(button => {
    button.addEventListener('click', closePopup);
  });

  // Close with Esc key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !popup.classList.contains('compatibility-popup--hidden')) {
      closePopup();
    }
  });

  // --- TABS FUNCTIONALITY ---

  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      // Deactivate all tabs and panels
      tabs.forEach(t => t.classList.remove('active'));
      panels.forEach(p => p.classList.remove('active'));

      // Activate clicked tab
      tab.classList.add('active');

      // Activate corresponding panel
      const targetId = tab.getAttribute('aria-controls');
      const targetPanel = document.getElementById(targetId);
      targetPanel.classList.add('active');

      // Reset and trigger search for the new active tab
      const currentInput = targetPanel.querySelector('.compatibility-search__input');
      if (currentInput) {
        // Just trigger the input event to hide/show items correctly
        currentInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  });

  // --- SEARCH FUNCTIONALITY ---

  function resetSearch(allPanels) {
    allPanels.forEach(panel => {
      // Clear input
      const input = panel.querySelector('.compatibility-search__input');
      if (input) input.value = '';
      
      // Unhide all items
      panel.querySelectorAll('.compatibility-list__model-item').forEach(item => {
        item.classList.remove('model-hidden');
      });
      panel.querySelectorAll('.compatibility-list__company').forEach(company => {
        company.classList.remove('company-hidden');
      });
    });
  }

  function performSearch(event) {
    const input = event.target;
    const searchTerm = input.value.trim().toLowerCase();
    const currentPanel = input.closest('.compatibility-tabs__panel');
    const companies = currentPanel.querySelectorAll('.compatibility-list__company');

    companies.forEach(company => {
      // 1. Get the company name and convert to lowercase
      const companyName = company.dataset.companyName.toLowerCase();
      const modelsList = company.querySelector('.compatibility-list__models');
      const modelItems = modelsList.querySelectorAll('.compatibility-list__model-item');
      
      // 2. Check if the search term matches the company name
      const isCompanyMatch = companyName.includes(searchTerm);
      let visibleModelCount = 0;

      modelItems.forEach(item => {
        const modelName = item.dataset.modelName.toLowerCase();
        
        // 3. Show item if the model matches OR if the company matches
        if (isCompanyMatch || modelName.includes(searchTerm)) {
          item.classList.remove('model-hidden');
          visibleModelCount++;
        } else {
          item.classList.add('model-hidden');
        }
      });

      // Handle company heading visibility based on models or company match
      if (visibleModelCount === 0) {
        company.classList.add('company-hidden');
      } else {
        company.classList.remove('company-hidden');
      }
    });
  }

  // Attach input listener to all search bars
  searchInputs.forEach(input => {
    input.addEventListener('input', performSearch);
    
    // Clear button functionality (native search type clear)
    input.addEventListener('search', (e) => {
        if(e.target.value === '') {
            performSearch(e);
        }
    });
  });
});